import { Sheet, SheetContent } from "@/components/ui/sheet";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { CreateOrEditDepartmentContent } from "./CreateOrEditDepartmentContent";
import { DepartmentFormSchema } from "../forms/Forms";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onBack: () => void;
}

export const CreateDepartmentSheet = ({ isOpen, onBack, onClose }: Props) => {
  const form = useForm<z.infer<typeof DepartmentFormSchema>>({
    resolver: zodResolver(DepartmentFormSchema),
  });

  return (
    <Sheet open={isOpen}>
      <SheetContent onClose={onClose}>
        <CreateOrEditDepartmentContent
          form={form}
          mode="create"
          onBack={onBack}
        />
      </SheetContent>
    </Sheet>
  );
};
